<template>
  <div>
    <joint-project-index
        :table-columns="columns"
        :api="api"
        :share-platform="sharePlatName"
        :join-project-title="['多样性','代谢组']"
        table-col-key="trans_metabo_col1"
        @addProject="addTransMetaboProject"
        :projectInfo="projectInfo"
    >
      <!-- 专属单元格 -->
      <template slot="sampleNames" slot-scope="{text,record}">
        <sample-group-detail :right-groups="record.metSampleName" :left-groups="record.rnaSampleName"
                             :title="['转录组','代谢组']"></sample-group-detail>
      </template>
    </joint-project-index>
  </div>

</template>

<script>

import {jointProjectColumns} from "@/utils/data/tableCol/projectTableCol";
import JointProjectIndex from "@/components/project/jointProject/JointProjectIndex.vue";
import {
  addTransMetaboProject,
  transMetaboProjectChangeUser,
  transMetaboProjectCustomerRemarkEdit,
  transMetaboProjectDel,
  transMetaboProjectPage,
  transMetaboProjectRemarkEdit
} from "@/api/transMetabo";
import SampleGroupDetail from "@/components/project/transMetabo/SampleGroupDetail.vue";
import {
  projectList,
} from "@/api/project";

export default {
  components: {SampleGroupDetail, JointProjectIndex},
  data() {
    return {
      platName: 'transMetabo',
      sharePlatName: 'TRANS_METABO',
      api: {
        getList: transMetaboProjectPage,
        del: transMetaboProjectDel,
        editRemark: transMetaboProjectRemarkEdit,
        editCustomerRemark: transMetaboProjectCustomerRemarkEdit,
        changeUser: transMetaboProjectChangeUser
      },
      isHasProject: false,
      projectInfo: {
        leftRightInfo: {
          titles:{
            left: '转录组',
            right: '代谢组'
          },
          platNames:{
            left: 'trans',
            right: 'metabo'
          },
          exampleProjectIds:{
            left: 'transProjectXXXXXXXXXXXXXX',
            right: 'metaboProjectXXXXXXXXXXXXXX'
          },
          webUrls:{
            left: 'projectTrans',
            right: 'projectMetabo'
          }
        }
      },
    };
  },
  computed: {
    columns() {
      let column
      column = jointProjectColumns(this.searchConditionTag || []).filter(item => !item.model || item.model.includes(this.platName))
      if (['ANALYST', 'TECH'].includes(this.$store.getters["right/getRole"])) {
        column.splice(column.length - 1, 1)
      }
      return column
    }
  },
  async mounted() {
    this.role = this.$store.getters["right/getRole"]
    await this.getData(true)
    if (this.role === 'USER'&&!this.isHasProject) {
      let flagInfo = await this.getTransMetaboAllProject()
      const pro = [flagInfo.transNum, flagInfo.metaboNum].map(num => num === 0)
      const [noTrans, noMetabo] = pro
      if (!flagInfo.flag) {
        let confirmText = `<span >必须同时有转录组和代谢组项目才能使用联合分析功能！</span>`
        let tip = ''
        if (noTrans && noMetabo) {
          tip = `<span>您当前暂无转录组和代谢组项目！</span>`
        } else if (noTrans) {
          tip = `<span >您当前暂无转录组项目!</span>`
        } else if (noMetabo) {
          tip = `<span >您当前暂无代谢组项目!</span>`
        }
        if (tip) confirmText = confirmText + tip
        this.$confirmUi(confirmText, '温馨提示', {
          confirmButtonText: '前往代谢组交付系统',
          cancelButtonText: '前往转录组交付系统',
          dangerouslyUseHTMLString: true,
          type: 'error',
          showCancelButton: noMetabo,
          showConfirmButton: noTrans,
          closeOnClickModal: false,
          showClose: false,
          confirmButtonClass: 'el-button--primary',
          cancelButtonClass: 'el-button--success',
          customClass: 'no-confirm'
        }).then(() => {
          this.$router.push({path: '/projectMetabo'})
        }).catch(() => {
          this.$router.push({path: '/projectTrans'})
        })
      }
    }

  },
  methods: {
    async addTransMetaboProject(sendData, callback) {
      const data = {
        rnaProjectId: sendData.leftProjectId,
        metProjectId: sendData.rightProjectId,
        customerRemark: sendData.customerRemark,
        remark: sendData.remark,
      }
      try {
        const res = await addTransMetaboProject(data)
        callback(res?.code === 200)
      } catch (err) {
        // 接口报错直接回传false
        callback(false)
      }
    },
    async getTransMetaboAllProject() {
      const [transRes, metaboRes] = await Promise.all([
        projectList({}, 'trans'),
        projectList({}, 'metabo')
      ]);
      if (transRes?.code === 200 && metaboRes?.code === 200) {
        return {
          flag: transRes.data.totalNum > 0 && metaboRes.data.totalNum > 0,
          transNum: transRes.data.totalNum,
          metaboNum: metaboRes.data.totalNum
        }
      }
      return {
        flag: false,
        transNum: 0,
        metaboNum: 0
      }
    },
    async getData() {
      const res = await transMetaboProjectPage({},{})
      if(res?.code===200){
        this.isHasProject = Number(res.data.total) > 0
      }
    },
    openDiversityDetail(id) {
      window.open(`/diversity/desc?projectId=${id}`);
    }
  }
};
</script>
